/**
 * Created by Ning Jiang on 2021-06-04.
 */

import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/text/BitmapTextStyleOptions";
import {TombstoneRip} from "../TombstoneRip";
import {Layers, TombstoneRipLayers} from "./TombstoneRipLayers";
import {gsap, TimelineLite} from "gsap";
import {TombstoneRipGameAssets} from "../TombstoneRipGameAssets";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";

export class Ways extends PIXI.Container {

    private readonly _numberStyle:BitmapTextStyleOptions = {
        fontName : TombstoneRipGameAssets.BITMAP_FONT_MULTIPLIER,
        fontSize : 30,
        tint : 0xffffff
    };

    private readonly _numberGlowStyle:BitmapTextStyleOptions = {
        fontName : TombstoneRipGameAssets.BITMAP_FONT_SUPERFS_GLOW_MUL,
        fontSize : 30,
        tint : 0xffffff
    };

    private _staticWays:PIXI.Sprite;
    private _numberText:PIXI.BitmapText;
    private _numberGlowText:PIXI.BitmapText;
    private _splitSpine:PIXI.spine.Spine | null;
    private _splitTl:TimelineLite | null;
    private _isSplitPlaying:boolean;

    private readonly _defaultReelValue:number[] = [2, 3, 3, 3, 2];
    private _currentReelValue:number[] = [2, 3, 3, 3, 2];

    public get currentValue():number {
        return this._currentReelValue.reduce((a, b) => {
            return a * b;
        }, 1);
    }

    constructor() {
        super();

        this._staticWays = new PIXI.Sprite(TombstoneRip.assetLoader.getTextures(`ways`)[0]);
        this._staticWays.anchor.set(0.5, 0.5);
        this._staticWays.y = 4 + 13;
        this.addChild(this._staticWays);

        this._numberGlowText = new PIXI.BitmapText(this.currentValue.toString(), this._numberGlowStyle);
        (<PIXI.Point>this._numberGlowText.anchor).set(0.5, 1);
        this._numberGlowText.scale.set(0.4);
        this._numberGlowText.y = -18;
        this._numberGlowText.letterSpacing = -8;
        this._numberGlowText.visible = false;
        this.addChild(this._numberGlowText);

        this._numberText = new PIXI.BitmapText(this.currentValue.toString(), this._numberStyle);
        (<PIXI.Point>this._numberText.anchor).set(0.5, 1);
        this._numberText.letterSpacing = -8;
        this.addChild(this._numberText);

        this.position.set(70, 110);
        TombstoneRipLayers.getLayer(Layers.FOREGROUND_TOP)?.addChild(this);
    }

    private updateWaysDisplay(animate:boolean):void {
        const value = this.currentValue;
        if(value === parseInt(this._numberText.text)) {
            return;
        }
        this._numberText.text = this._numberGlowText.text = value.toString();
        if(animate) {
            if(this._numberText.visible) {
                gsap.fromTo(this._numberText.scale, {x : 1.3, y : 1.3}, {x : 1, y : 1, duration : 0.4});
            }
            if(this._numberGlowText.visible) {
                gsap.fromTo(this._numberGlowText.scale, {x : 0.52, y : 0.52}, {x : 0.4, y : 0.4, duration : 0.4});
            }
        }
    }

    public reset():void {
        this._currentReelValue = this._defaultReelValue.concat();
        this.updateWaysDisplay(false);
    }

    public reelSplit(reelId:number):void {
        // this.playSplit("WRSSplit");
        this._currentReelValue[reelId] *= 2;
        this.updateWaysDisplay(true);
    }

    public xSplit():void {
        // this.playSplit("WXSSplit");
        this._currentReelValue[0] = 3;
        this._currentReelValue[1] = this.getReelWays(1);
        this._currentReelValue[2] = this.getReelWays(2);
        this._currentReelValue[3] = this.getReelWays(3);
        this.updateWaysDisplay(true);
    }

    private playSplit(name:string):void {
        this.resetSplit();
        this._isSplitPlaying = true;
        this._splitSpine = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset(name));
        this._splitSpine.autoUpdate = true;
        this._splitSpine.position.set(0, 0);
        this._splitSpine.scale.set(0.6);
        this.addChild(this._splitSpine);
        this._splitTl = new TimelineLite();
        this._splitTl.add(new SpineTween(this._splitSpine, 0, "splitting"));
        this._splitTl.add(new SpineTween(this._splitSpine, 0, "splitDone"));
        this._splitTl.add(gsap.to(this._splitSpine, {duration : 0.2, alpha : 0, onComplete : () => this.resetSplit()}));
    }

    private resetSplit():void {
        if(this._splitTl) {
            this._splitTl.kill();
            this._splitTl = null;
        }
        if(this._splitSpine) {
            this._splitSpine.state.clearTrack(0);
            this._splitSpine.skeleton.setToSetupPose();
            this._splitSpine.state.setEmptyAnimation(0, 0);
            if(this._splitSpine.parent) {
                this._splitSpine.parent.removeChild(this._splitSpine);
            }
            this._splitSpine.destroy();
            this._splitSpine = null;
        }
    }

    private getReelWays(reelId:number):number {
        if(TombstoneRip.model.parsedGameData.doReelNudge[reelId]) {
            return 3;
        }
        let sum = 0;
        for(let symId = 0; symId < 3; symId++) {
            sum += TombstoneRip.reels[reelId].getSymbol(symId, false, false).symbolSize;
        }
        return sum;
    }

    public setColor(color:number, isSuper:boolean):void {
        this._numberText.tint = color;
        this._staticWays.tint = color;
        this._staticWays.texture = TombstoneRip.assetLoader.getTextures(`ways${isSuper ? "_super" : ""}`)[0];
        this._numberGlowText.visible = isSuper;
        this._numberText.visible = !this._numberGlowText.visible;
    }
}